<template>
  <div
    class="border mx-6 flex-1 hover:shadow-lg"
    :class="{
      'shadow-lg': currentSubscription.plan_id == subscription[interval].id,
      'border-brand-lighter': interval == 'monthly',
      'border-brand-light': interval == 'yearly',
    }"
  >
    <div
      class="py-4 text-center uppercase text-lg tracking-wider text-grey-darker"
      :class="{
        'bg-brand-lightest': interval == 'monthly',
        'bg-brand-lighter': interval == 'yearly',
      }"
    >
      {{ subscription[interval].name }}
    </div>

    <div
      class="py-4 text-center flex flex-col"
      :class="{
        'bg-modal-gradient': interval == 'monthly',
        'bg-modal-gradient-2': interval == 'yearly',
      }"
    >
      <div class="w-full flex text-white justify-center items-center">
        <span
          class="font-light text-2xl text-right currency -mt-3 whitespace-no-wrap"
          >{{ subscription[interval].currency == "NZD" ? "NZ" : "" }}$</span
        >
        <span class="font-light text-5xl amount">{{
          parseFloat(subscription[interval].price).toFixed(2)
        }}</span>
        <span
          class="font-light text-2xl text-left per-month self-end mb-2 ml-1"
          v-if="interval == 'monthly'"
          >/mo</span
        >
        <span
          class="font-light text-3xl text-left per-month self-end mb-2 ml-1"
          v-if="interval == 'yearly'"
          >/yr</span
        >
      </div>
      <p
        class="text-white uppercase text-xs"
        v-if="
          subscription[interval].description &&
          subscription[interval].description.pricing_description
        "
      >
        {{ subscription[interval].description.pricing_description }}
      </p>
    </div>

    <div
      class="px-8 py-4 pb-6 h-20 text-center text-sm text-grey-darker text-center flex justify-center items-center"
      :class="{
        'bg-grey-lightest': interval == 'monthly',
        'bg-grey-lighter': interval == 'yearly',
      }"
      v-if="
        subscription[interval].description &&
        subscription[interval].description.subtext
      "
      v-html="subscription[interval].description.subtext"
    ></div>

    <div
      class="px-8 py-4 text-center uppercase bg-grey-lightest text-xs text-grey-darker text-center"
      v-if="
        subscription[interval].description &&
        subscription[interval].description.pricing_options
      "
    >
      <p
        class="p-1"
        v-for="option in subscription[interval].description.pricing_options"
      >
        {{ option }}
      </p>
      <p class="p-1 text-orange">
        {{ subscription[interval].description.savings }}
      </p>
    </div>

    <div
      class="py-4 px-8 bg-white text-sm text-grey-darker text-center flex flex-col h-64 justify-between"
    >
      <div class="flex-none justify-center items-center">
        <ul
          class="text-left"
          v-if="
            subscription[interval].description &&
            subscription[interval].description.features
          "
        >
          <li
            v-for="(feature, idx) in subscription[interval].description
              .features"
            class="p-1"
            v-if="isLast(feature, subscription[interval].description.features)"
          >
            <i class="fa fa-check text-brand"></i>
            <span :class="{ 'font-medium': idx == 0 }">{{ feature }}</span>
          </li>
        </ul>
      </div>
      <div class="flex-none">
        <button
          class="px-4 py-2 text-white rounded text-lg mt-6 hover:bg-brand-dark font-medium"
          :class="{
            'bg-brand-darker':
              currentSubscription.plan_id == subscription[interval].id,
            'bg-brand':
              currentSubscription.plan_id != subscription[interval].id,
          }"
          @click.prevent="selectPlan(subscription[interval].id)"
        >
          <span v-if="currentSubscription.plan_id == subscription[interval].id">
            <i class="fa fa-check"></i>
            <span class="md:inline-block hidden">Selected</span>
          </span>

          <span v-else>Select</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "subscription",
    "subscription-type",
    "current-subscription",
    "interval",
  ],

  methods: {
    selectPlan(plan_id) {
      this.$emit("select-plan", plan_id);
    },

    isLast(feature, features) {
      if (this.subscriptionType == "medium") {
        return true;
      }

      return _.last(features) != feature;
    },
  },
};
</script>

<style>
</style>
